 var swiper = new Swiper(".mega-slider", {
    scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      0: {
        slidesPerView: 2.6,
        spaceBetween: 10,
      }
      
    },    
});


  // function bindMouseOverToMegaMenu (item) {
  //   item.addEventListener("mouseover", () => {
  //       item.setAttribute("open", true);
  //       item.querySelector(".mega-menu__content").addEventListener("mouseover", () => {
  //         item.setAttribute("open", true);
  //       });
  //       item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
  //         item.removeAttribute("open");
  //       });
  //     item.addEventListener("mouseleave", () => {
  //       item.removeAttribute("open");
  //     });
  //   });
  // }
  // let items = document.querySelector(".header__inline-menu").querySelectorAll("details.mega-menu");
  // items.forEach(bindMouseOverToMegaMenu);
  

